/**
 * Проверка номера на дубликат
 */
export const getDuplicates = (params) => ({
    url: '/phones/duplicates',
    method: 'GET',
    params,
});
